import { keepPreviousData, useQuery } from "@tanstack/react-query";
import * as Immutable from "immutable";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = {
  widget: null,
  cachedValues: null
};
const url = qualifyUrl("plugins/org.graylog.plugins.widgetexport/widgetexport");
export const fetchWidgetData = (exportCallId) => fetch("GET", `${url}/${exportCallId}`).then(
  ({ created_at, widget, data }) => ({
    widget,
    cachedValues: data && {
      type: data.type,
      calculatedAt: created_at,
      result: [data.results],
      types: Immutable.List(),
      hasError: void 0,
      errorMessage: void 0
    }
  })
);
const useWidgetData = (exportCallId) => {
  const { data, refetch, isFetching } = useQuery({
    queryKey: ["exported-widget-date", exportCallId],
    queryFn: () => defaultOnError(
      fetchWidgetData(exportCallId),
      "Fetching widget data failed with status",
      "Could not retrieve widget data"
    ),
    placeholderData: keepPreviousData,
    enabled: !!exportCallId
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    refetch,
    isFetching
  };
};
export default useWidgetData;
